import React from "react";
import ContextRenderChangeLanguage from "./render/Context.RenderChangeLanguage";
import { useLocation } from "react-router-dom";

export const ContextLanguage = React.createContext();

export const PageSaparate = [
  "/TH",
  "/th",
  "/OurServices/TH",
  "/Pricing/TH",
  "/FAQ/TH",
  // "/Glossary/TH",
  "/AboutUs/TH",
  "/ContactUs/TH",
  "/Bangkok/TH",
  "/Pattaya/TH",
  "/TermsAndConditions/TH",
  "/PrivacyNotice/TH",
];

export const PageSaparateEn = [
  "/",
  "/",
  "/OurServices",
  "/Pricing",
  "/FAQ",
  // "/Glossary",
  "/AboutUs",
  "/ContactUs",
  "/Bangkok",
  "/Pattaya",
  "/TermsAndConditions",
  "/PrivacyNotice",
];

export const AllSaparate = [...PageSaparate, ...PageSaparateEn];

export const FunctionClickIsNotPageSaparate = ({ pathname }) => {
  return !AllSaparate.includes(pathname);
};

const ContextLanguageProvider = ({ children }) => {
  const [language, setLanguage] = React.useState("");
  const location = useLocation();

  React.useEffect(() => {
    const current_language = localStorage.getItem("language");

    // const split = location.pathname.split("/");
    // const checkIsTH = split[split.length - 1];
    // const pageLanguage = checkIsTH ? "TH" : "EN";

    if (PageSaparate.includes(location.pathname)) {
      setLanguage("TH");
    } else if (PageSaparateEn.includes(location.pathname)) {
      setLanguage("EN");
    } else if (current_language) {
      setLanguage(current_language);
    } else {
      setLanguage("EN");
    }
  }, []);

  const FunctionChangeLanguageTo = (language) => {
    setLanguage(language);
    localStorage.setItem("language", language);
  };

  const contextValues = {
    language,
    setLanguage,
    FunctionChangeLanguageTo,
    ContextRenderChangeLanguage,
  };

  return (
    <ContextLanguage.Provider value={contextValues}>
      {children}
    </ContextLanguage.Provider>
  );
};

export default ContextLanguageProvider;
